var _circle, _circle2, _g, _path, _path2, _path3, _circle3, _circle4, _circle5, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgServiceError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 48.9898,
    transform: "rotate(-15 60 60)",
    fill: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_48_2545",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 99,
    height: 99
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.8779,
    cy: 59.5442,
    r: 48.9898,
    fill: "#F6F6F6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_48_2545)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M44.5685 63.3716H75.1871L98.1511 128.436H21.6045L44.5685 63.3716Z",
    fill: "url(#paint0_linear_48_2545)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.777 55.717C17.777 49.7984 22.5749 45.0005 28.4935 45.0005L91.2617 45.0005C97.1802 45.0005 101.978 49.7984 101.978 55.717V55.717C101.978 61.6356 97.1802 66.4335 91.2617 66.4335H28.4935C22.5749 66.4335 17.777 61.6356 17.777 55.717V55.717Z",
    fill: "#E9E9E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4834 40.4077C77.4834 38.0957 77.028 35.8063 76.1432 33.6703C75.2585 31.5343 73.9616 29.5934 72.3268 27.9586C70.692 26.3238 68.7511 25.0269 66.6151 24.1422C64.4791 23.2574 62.1897 22.802 59.8777 22.802C57.5657 22.802 55.2763 23.2574 53.1403 24.1422C51.0042 25.0269 49.0634 26.3238 47.4286 27.9586C45.7937 29.5934 44.4969 31.5343 43.6121 33.6703C42.7274 35.8063 42.272 38.0957 42.272 40.4077L59.8777 40.4077H77.4834Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8882 41.542C36.4696 40.8244 37.3438 40.4076 38.2673 40.4076L81.4879 40.4076C82.4114 40.4076 83.2856 40.8244 83.867 41.542L86.6689 45.0004L33.0863 45.0004L35.8882 41.542Z",
    fill: "#C8C8C8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.7409,
    cy: 55.717,
    r: 3.06186,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.8777,
    cy: 55.717,
    r: 3.06186,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.0143,
    cy: 55.717,
    r: 3.06186,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.2132 82.5492C56.7509 82.5492 53.6177 83.9379 51.3379 86.1892C50.7363 86.7833 49.767 86.7773 49.1729 86.1757C48.5788 85.5741 48.5849 84.6048 49.1865 84.0106C52.0169 81.2154 55.9146 79.4873 60.2132 79.4873C64.5119 79.4873 68.4096 81.2154 71.24 84.0106C71.8416 84.6048 71.8477 85.5741 71.2536 86.1757C70.6595 86.7773 69.6902 86.7833 69.0886 86.1892C66.8088 83.9379 63.6756 82.5492 60.2132 82.5492ZM62.5098 94.0355C62.5098 95.3037 61.4817 96.3319 60.2134 96.3319C58.9452 96.3319 57.917 95.3037 57.917 94.0355C57.917 92.7672 58.9452 91.7391 60.2134 91.7391C61.4817 91.7391 62.5098 92.7672 62.5098 94.0355ZM55.8739 90.008C57.211 88.8157 58.4363 88.4019 60.0924 88.4019C61.7147 88.4019 63.1906 89.0084 64.3105 90.0077C64.9413 90.5706 65.9091 90.5156 66.4721 89.8847C67.035 89.2539 66.98 88.2861 66.3491 87.7232C64.6891 86.2419 62.4942 85.3401 60.0924 85.3401C57.7243 85.3401 55.7629 86.0046 53.8361 87.7228C53.205 88.2856 53.1497 89.2533 53.7124 89.8843C54.2751 90.5154 55.2429 90.5708 55.8739 90.008Z",
    fill: "#D9D9D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_48_2545",
    x1: 75.9467,
    y1: 54.186,
    x2: 75.9467,
    y2: 128.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8C8C8",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceError);
export default __webpack_public_path__ + "static/media/serviceError.f29eebbaddac0c97a5c77267f1b8656b.svg";
export { ForwardRef as ReactComponent };